

console.log ('helloo!!!');

const artImages = document.querySelectorAll('.art-item');

for (let i = 0; i < artImages.length; i++){
    artImages[i].addEventListener('click', () => {
        artImages[i].classList.toggle('expanded');
    });
} 